import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import Logo from "../../Imagens/logoPentagov.jpg";
import "./index.css";
import {
  atualizarSenhaOperador,
  validarCodigoRecuperacao,
} from "../../Services/recoveryApi";

const RecuperarSenhaConfirmar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location?.state?.email) {
      setEmail(location.state.email);
    }
  }, [location]);

  const handleResetar = async () => {
    if (!email || !token || !novaSenha) {
      Swal.fire("Atenção", "Preencha todos os campos.", "warning");
      return;
    }

    if (novaSenha !== confirmarSenha) {
      Swal.fire("Atenção", "As senhas não conferem.", "warning");
      return;
    }

    setLoading(true);
    try {
      const validacao = await validarCodigoRecuperacao(email, token);

      const recupera = validacao?.Recupera;

      if (!recupera?.email) {
        Swal.fire("Erro", "Código inválido ou expirado.", "error");
        return;
      }

      await atualizarSenhaOperador(recupera.email, novaSenha);

      Swal.fire(
        "Sucesso",
        "Senha alterada com sucesso! Faça login novamente.",
        "success"
      );
      navigate("/");
    } catch (err) {
      const msg =
        err?.response?.data?.errors?.default ||
        err?.message ||
        "Falha ao alterar senha.";

      Swal.fire("Erro", msg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="TelaLoginInicial" align="center">
      <div className="PainelLogin">
        <div className="login-container p-4 shadow">
          <div id="painelLOGO">
            <img
              style={{ width: "100%", borderRadius: "10px" }}
              src={Logo}
              alt="Logo PentaGOV"
            />
          </div>

          <div style={{ paddingTop: "30px" }}>
            <h5 className="mb-3" style={{ color: "var(--color-text-primary)" }}>
              Definir nova senha
            </h5>

            <input
              className="form-control form-control-lg mb-3"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <input
              className="form-control form-control-lg mb-3"
              placeholder="Código"
              value={token}
              onChange={(e) => setToken(e.target.value)}
            />

            <input
              type="password"
              className="form-control form-control-lg mb-3"
              placeholder="Nova senha"
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
            />

            <input
              type="password"
              className="form-control form-control-lg mb-4"
              placeholder="Confirmar nova senha"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              onKeyDown={(e) =>
                e.key === "Enter" && handleResetar()
              }
            />

            <button
              className="btn btn-primary btn-lg w-100"
              onClick={handleResetar}
              disabled={loading}
            >
              {loading ? "SALVANDO..." : "ALTERAR SENHA"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecuperarSenhaConfirmar;
